export { default as PerformanceBadges } from './PerformanceBadges';
